export default __webpack_public_path__ + "static/media/designkit_wrapper.52cae6d9.svg";